import {
	axiosErrorHandler,
	deletes,
	get,
	post,
	put,
} from 'models/shared/helpers/axiosInstance';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import { SkuImageType } from '../enums/sku-image.enum';
import { CreateSkuDto, Sku, SkuFilterDto } from '../interfaces/sku.interface';

const basePath = '/v1/skus';

export const createSku = async (dto: CreateSkuDto) => {
	try {
		const res = await post<Sku>(basePath, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getSkus = async (filter?: SkuFilterDto) => {
	try {
		const path = filter ? buildPathWithQueryParams(basePath, filter) : basePath;
		const res = await get<PaginatedDocuments<Sku>>(path);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getSkuById = async (id: string) => {
	try {
		const res = await get<Sku>(`${basePath}/${id}`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getSkuByCode = async (code: string) => {
	try {
		const res = await get<Sku>(`${basePath}/code/${code}`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getNextSkuVersionId = async (
	modelId: string,
	version?: string,
): Promise<number> => {
	try {
		const params = new URLSearchParams({ model: modelId });
		if (version) params.append('version', version);
		const res = await get<{ nextId: number }>(
			`${basePath}/next-version-id?${params.toString()}`,
		);
		return res.data.nextId;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateSku = async (id: string, dto: Partial<CreateSkuDto>) => {
	try {
		const res = await put<Sku>(`${basePath}/${id}`, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const addImageToSku = async (
	id: string,
	imageType: SkuImageType,
	file: File,
) => {
	try {
		const data = new FormData();
		data.append('name', file.name);
		data.append('file', file);
		const res = await put<Sku>(`${basePath}/${id}/images/${imageType}`, data, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const deleteSkuImage = async (id: string, imageId: string) => {
	try {
		const res = await deletes<Sku>(`${basePath}/${id}/images/${imageId}`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
